import { breakpointsTailwind } from "@vueuse/core";

export default function useIsMobile(): Ref<boolean> {
  const breakpoints = useBreakpoints(breakpointsTailwind);

  return breakpoints.smaller("sm");
}
